import { tsInitVueGrid } from './js-utils'
import SentMailGrid from './vue-components/sent-mail-grid.vue'

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('body.ospe-activity-email-messages')) {
    const mailGridEl = document.querySelector('div[data-is="SentMailGrid"]')
    if (mailGridEl instanceof HTMLElement) {
      window.sentMailGrid = tsInitVueGrid(SentMailGrid, mailGridEl)
    }
  }
})
